module.exports = __webpack_public_path__ + "assets/fontawesome-webfont.32400f4e08932a94d8bfd2422702c446.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./~/font-awesome/fonts/fontawesome-webfont.eot
 ** module id = 390
 ** module chunks = 0
 **/